<template>
  <v-form @submit.prevent="register" ref="form">
    <v-card class="rounded-4">
        <v-toolbar flat height="55px">
            <span class="font-weight-bold">Add new employee</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog" :disabled="disabled">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-alert v-show="errorAdd" :value="true" color="warning" icon="warning" outline style="margin:10px 2px -3px 2px;">
              {{ errorMessage }}
          </v-alert>
          <v-layout row wrap> 
            <v-flex xs12 style="padding: 10px 20px 0px 20px; ">                
              <v-text-field label="Email" 
                v-model="email" 
                :rules="[rules.required, rules.email, rules.min]"
                @keyup="errorAdd=false"
                readonly></v-text-field>  
            </v-flex>
          </v-layout>
          <v-layout row wrap> 
            <v-flex xs12 style="padding: 0px 20px 0px 20px;">      
                <v-text-field label="First Name" 
                  v-model="firstName" 
                  :rules="[rules.required]"
                  :disabled="disabled"
                  @keyup="errorAdd=false"></v-text-field> 

                <v-text-field label="Last Name" 
                  v-model="lastName" 
                  :rules="[rules.required]"
                  :disabled="disabled"
                  @keyup="errorAdd=false"></v-text-field>
                  
            </v-flex>
          </v-layout>
        </v-card-text>  
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit" :loading="loading" style="color:white;margin-right:25px;">Save</v-btn>
        </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
  import registrationApi from '@/api/registration'

  export default {
    name: 'dialog',
    data () {
      return {
        loading: false,
        disabled: false,
        error: false,
        errorAdd: false,
        email: '',
        firstName: '',
        middleName: '',
        lastName: '',
        role: '', 
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          } 
        },
        errorMessage: '', 
        teamId: '0',
        mode: '',
        avatar: '',
      }
    },
    methods: {
      setParamsAdd(email){
        this.firstName = ''
        this.lastName = ''
        this.teamId = 0  
        this.mode = 'Add'
        this.email = email
      },
      closeDialog() {
          this.$emit('update:dialogAddNew', false)
      },
      async addMember() {
        try {
            this.loading = true
            this.disabled = true
            
            var data = {
                teamId: this.teamId, 
                email: this.email, 
                firstName: this.firstName, 
                lastName: this.lastName,
            }
            const response = await registrationApi.addmember(data)
            
            if (response && response.status == 200) {
              var success = JSON.parse(response.data.registrationItem.success)
              
              if (success) {
                this.$emit('send', 'Add')
              } else {
                this.errorMessage = JSON.stringify(response.data.registrationItem.errorMessage)
                this.errorAdd = true
              }
              this.loading = false
              this.disabled = false
            }
          } catch(error) {
            this.errorMessage = error
            this.error = true
          }
       },
       async register() {
        if (this.$refs.form.validate()) {
          this.addMember()
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.errorAdd = false
        this.errorMessage = ''
      },
    },
    computed: {},
    created() {}
  }
</script>